var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 30,
    viewBox: "0 0 17 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83581 0.169621C8.4624 0.435705 6.90565 1.33691 6.14036 2.30852C4.99229 3.76606 4.70336 4.75487 4.57905 7.6502L4.4617 10.3808H2.4809C1.08038 10.3808 0.418758 10.4756 0.222695 10.7045C0.03887 10.9187 -0.0319244 11.9206 0.0131918 13.6674L0.0813462 16.3067L2.29732 16.3734L4.51329 16.4403L4.57713 22.764L4.64096 29.088H7.64071H10.6405L10.7043 22.7633L10.7681 16.4384L13.3441 16.3727L15.92 16.3067L15.9879 13.5366C16.0386 11.4765 15.9769 10.7177 15.748 10.5771C15.5785 10.473 14.3736 10.3863 13.0703 10.3842L10.7002 10.3808L10.8077 8.39686C10.9498 5.77808 11.0801 5.65793 13.9457 5.50363L16.16 5.38441V2.71195V0.0394836L13.5202 0.00323099C12.0683 -0.0167544 10.4103 0.0580746 9.83581 0.169621Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1f0a23c48264bcf397902a0f80c1fa05.svg";
export { ForwardRef as ReactComponent };